import style from './CancelTransfer.module.scss'

export const CancelTransfer = ({ callBack }: { callBack: () => void }) => (
    <button className={style.container} onClick={callBack}>
        Отменить перенос списка
    </button>
)
